import { Box, Flex, Textarea } from '@mantine/core';
import { useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './AskSiestaInput.module.css';

type Props = {
  variant?: 'light' | 'brand';
  onSubmit?: (message: string) => void;
  onFocus?: () => void;
  autoFocus?: boolean;
  disabled?: boolean;
  submitDisabled?: boolean;
};

export function AskSiestaInput({
  variant = 'light',
  onSubmit,
  onFocus,
  autoFocus,
  disabled,
  submitDisabled,
}: Props) {
  const [value, setValue] = useState('');
  const borderColor = variant === 'light' ? 'orange-1' : 'orange-6';
  const colorVar = `var(--mantine-color-${borderColor})`;
  const textColor = variant === 'light' ? 'orange.1' : 'orange.6';

  const canSubmit = !disabled && !submitDisabled;

  const handleSubmit = () => {
    if (canSubmit && value.trim() && onSubmit) {
      onSubmit(value.trim());
      setValue('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Box
      px="lg"
      py={8}
      mih={52}
      w="100%"
      c={textColor}
      fz="var(--mantine-font-size-textMd)"
      fw={FONT_WEIGHTS.medium}
      style={{
        borderRadius: 'var(--mantine-radius-xl)',
        border: `4px solid ${colorVar}`,
        background: 'transparent',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <Flex align="center">
        <Textarea
          placeholder="Ask me anything"
          value={value}
          onChange={e => setValue(e.currentTarget.value)}
          onKeyDown={handleKeyDown}
          onFocus={onFocus}
          autoFocus={autoFocus}
          disabled={disabled}
          autosize
          minRows={1}
          maxRows={6}
          classNames={{ input: classes.input }}
          styles={{
            root: { flex: 1, background: 'transparent' },
            wrapper: { background: 'transparent', padding: 0, margin: 0 },
            input: {
              border: 'none',
              outline: 'none',
              background: 'transparent',
              padding: 0,
              lineHeight: 'var(--mantine-line-height-md)',
              font: 'inherit',
              color: 'inherit',
              resize: 'none',
              scrollbarWidth: 'thin',
            },
          }}
        />
      </Flex>
    </Box>
  );
}
